/**
 * @generated SignedSource<<6aafa72666c9af1b3bd53f48c666d029>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type infoModalCorporate_QueryFragment$data = {
  readonly Placement: {
    readonly permissionCartClickOut: string;
  };
  readonly " $fragmentType": "infoModalCorporate_QueryFragment";
};
export type infoModalCorporate_QueryFragment$key = {
  readonly " $data"?: infoModalCorporate_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"infoModalCorporate_QueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "infoModalCorporate_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PlacementQueries",
      "kind": "LinkedField",
      "name": "Placement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "permissionCartClickOut",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "e314421595dd88b2b5f7b89d8aae0f96";

export default node;
